import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import EditableInput from '@/components/EditableInput.vue'
import EditableSelect from '@/components/EditableSelect.vue'
import EditableInputNumber from '@/components/EditableInputNumber.vue'

import { useVehiclesStore } from '@/store/vehicles'

import {
  InsuranceRequestsReturn,
  CarProfileUpdateableKeys,
  InsuranceRequestsCreate,
} from '@/models/carProfile'
import { PrimitiveNonNull } from '@/models/common'
import { formatKeysForTable } from '@/helpers/data-table'
import { CAR_YEARS_OPTIONS } from '@/constants/select-options'


export default /*@__PURE__*/_defineComponent({
  __name: 'InsuranceView',
  props: {
    insurance: {},
    isFieldsEditable: { type: Boolean, default: true }
  },
  setup(__props: any) {

const SendKeyMap: Record<string, keyof InsuranceRequestsCreate> = {
  market_price: 'MarketPrice',
  registration_number: 'RegistrationNumber',
  brand_id: 'BrandID',
  model_id: 'ModelID',
  vehicle_type_id: 'VehicleTypeID',
  vin: 'Vin',
  chassis: 'Chassis',
  engine_number: 'EngineNumber',
  year_of_manufacture: 'YearOfManufacture',
  engine_volume: 'EngineVolume',
  number_of_seats: 'NumberOfSeats',
}

const props = __props

const route = useRoute()

const vehiclesStore = useVehiclesStore()
const vehicleId = computed(() => route.params.id as string)

const loadingList = computed(
  () =>
    vehiclesStore.vehiclesDetails[vehicleId.value]?.updating.loadingKeys || []
)
const successList = computed(
  () =>
    vehiclesStore.vehiclesDetails[vehicleId.value]?.updating.successKeys || []
)

const isLoading = <K extends string>(key: K) => {
  return loadingList.value.includes(SendKeyMap[key] as CarProfileUpdateableKeys)
}

const isSuccess = <K extends CarProfileUpdateableKeys>(key: K) => {
  return successList.value.includes(SendKeyMap[key] as CarProfileUpdateableKeys)
}

const numericFields = [
  'market_price',
  'brand_id',
  'model_id',
  'vehicle_type_id',
  'engine_volume',
  'number_of_seats',
]

const selectFields = ['year_of_manufacture']

const textFields = ['registration_number', 'vin', 'chassis', 'engine_number']

const priceFields = ['market_price']

const tableData = computed(() => {
  if (!props.insurance) return []

  return formatKeysForTable(props.insurance, [
    'market_price',
    'registration_number',
    'brand_id',
    'model_id',
    'vehicle_type_id',
    'vin',
    'chassis',
    'engine_number',
    'year_of_manufacture',
    'engine_volume',
    'number_of_seats',
  ])
})

const handleEditableFields = <
  V extends PrimitiveNonNull | PrimitiveNonNull[],
  I extends string,
  K extends keyof typeof SendKeyMap
>(
  value: V,
  insuranceId: I,
  key: K
) => {
  vehiclesStore.updateInsurance(vehicleId.value, insuranceId, {
    [SendKeyMap[key]]: value,
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    data: tableData.value,
    style: {"width":"100%"},
    "show-header": false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, null, {
        default: _withCtx(({ row: { label } }) => [
          _createTextVNode(_toDisplayString(label), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, { prop: "value" }, {
        default: _withCtx(({ row: { key, value } }) => [
          (textFields.includes(key))
            ? (_openBlock(), _createBlock(EditableInput, {
                key: 0,
                editable: _ctx.isFieldsEditable,
                sourceValue: value,
                loading: isLoading(key),
                success: isSuccess(key),
                onSave: val => handleEditableFields(val, `${_ctx.insurance?.id}`, key)
              }, null, 8, ["editable", "sourceValue", "loading", "success", "onSave"]))
            : _createCommentVNode("", true),
          (selectFields.includes(key))
            ? (_openBlock(), _createBlock(EditableSelect, {
                key: 1,
                editable: _ctx.isFieldsEditable,
                sourceValue: value,
                options: _unref(CAR_YEARS_OPTIONS),
                loading: isLoading(key),
                success: isSuccess(key),
                onSave: val => handleEditableFields(val, `${_ctx.insurance?.id}`, key)
              }, null, 8, ["editable", "sourceValue", "options", "loading", "success", "onSave"]))
            : _createCommentVNode("", true),
          (numericFields.includes(key))
            ? (_openBlock(), _createBlock(EditableInputNumber, {
                key: 2,
                min: 0,
                "is-pricing-input": priceFields.includes(key),
                editable: _ctx.isFieldsEditable,
                sourceValue: value,
                loading: isLoading(key),
                success: isSuccess(key),
                onSave: val => handleEditableFields(val, `${_ctx.insurance?.id}`, key)
              }, null, 8, ["is-pricing-input", "editable", "sourceValue", "loading", "success", "onSave"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})